import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 540.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,540.000000) scale(0.100000,-0.100000)">


<path d="M5280 5023 c-19 -2 -78 -10 -130 -19 -353 -59 -664 -195 -948 -414
-86 -67 -107 -101 -99 -161 5 -36 15 -53 60 -96 79 -75 104 -74 222 13 272
198 539 304 900 359 384 58 866 -70 1223 -323 124 -88 131 -92 176 -92 35 0
46 6 97 60 31 33 60 71 63 85 6 25 -6 90 -21 110 -22 29 -113 95 -278 203 -35
22 -219 109 -258 122 -21 6 -41 9 -44 6 -4 -3 -1 -6 5 -6 7 0 12 -5 12 -11 0
-5 -4 -8 -9 -4 -6 3 -28 3 -50 -1 -34 -5 -41 -10 -41 -29 0 -19 -7 -24 -40
-30 -33 -6 -40 -11 -40 -30 0 -19 -7 -24 -42 -31 -24 -4 -47 -7 -53 -6 -5 1
-32 6 -60 11 -27 5 -99 17 -160 26 -60 9 -129 21 -153 27 -41 10 -42 12 -26
29 10 11 13 19 8 19 -5 0 -8 18 -6 40 3 25 0 40 -7 40 -15 0 -11 72 3 82 7 5
5 8 -4 8 -13 0 -13 1 0 10 14 9 -214 12 -300 3z"/>
<path d="M5240 4576 c-308 -54 -577 -181 -767 -362 -39 -37 -43 -45 -43 -89 0
-44 4 -51 54 -101 78 -77 101 -76 226 15 190 136 363 208 590 246 109 19 186
19 308 0 238 -35 440 -124 660 -287 34 -25 53 -32 84 -32 36 1 47 8 84 48 53
56 64 76 64 115 0 48 -18 76 -84 129 -176 143 -390 246 -591 285 -133 26 -145
27 -145 17 0 -6 10 -10 22 -10 37 0 6 -20 -38 -25 -35 -4 -36 -3 -9 4 30 9 30
9 -10 11 -32 2 -34 4 -12 7 31 5 35 17 10 29 -32 14 -323 14 -403 0z"/>
<path d="M5335 4163 c-146 -12 -347 -100 -486 -212 -91 -74 -113 -108 -102
-161 7 -37 103 -130 133 -130 33 0 72 27 102 71 15 21 56 60 90 85 160 119
356 161 526 114 137 -38 232 -96 338 -206 76 -79 105 -84 172 -27 78 66 92
127 45 184 -66 78 -235 183 -371 230 -46 16 -63 17 -115 8 -115 -19 -147 -22
-147 -10 0 6 6 11 13 11 23 0 -17 20 -43 21 -14 0 -19 3 -12 6 6 2 10 9 6 14
-5 9 -63 10 -149 2z m182 -39 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2
13 -5z"/>
<path d="M5528 4153 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5192 3753 c-34 -20 -60 -39 -57 -41 2 -3 23 7 45 22 22 14 43 26 47
26 5 0 17 7 27 15 37 28 1 15 -62 -22z"/>
<path d="M2648 3743 c-21 -5 -23 -19 -5 -29 6 -4 8 -3 4 1 -4 5 3 15 15 22 23
12 18 15 -14 6z"/>
<path d="M5391 3703 c-1 -12 4 -25 9 -28 12 -7 12 2 0 30 -8 19 -9 19 -9 -2z"/>
<path d="M5099 3683 c-37 -45 -40 -55 -6 -24 20 19 37 36 37 38 0 9 -19 1 -31
-14z"/>
<path d="M2502 3661 c-30 -15 -32 -19 -18 -31 9 -7 14 -15 12 -18 -3 -2 -12 3
-21 11 -14 15 -19 14 -58 -7 -80 -44 -284 -165 -347 -205 -35 -23 -67 -41 -72
-41 -13 0 -9 -27 7 -40 11 -9 20 -8 42 7 15 11 60 37 98 59 39 21 78 43 87 49
9 5 50 28 90 49 40 21 75 42 78 45 3 3 23 15 45 26 22 11 55 28 74 39 32 18
32 20 12 27 -31 12 -27 33 6 24 23 -5 25 -4 14 9 -8 9 -14 16 -15 16 0 -1 -16
-9 -34 -19z"/>
<path d="M2625 3670 c-19 -8 -19 -9 2 -9 12 -1 25 4 28 9 7 12 -2 12 -30 0z"/>
<path d="M5232 3668 c-7 -7 -12 -20 -12 -30 0 -10 -4 -18 -8 -18 -4 0 -23 -31
-42 -68 -28 -54 -42 -71 -71 -83 -23 -11 -41 -29 -52 -52 -22 -45 -33 -52 -54
-36 -23 19 -11 96 27 170 36 71 39 86 7 39 -113 -167 -92 -414 48 -568 50 -56
76 -65 31 -11 -15 18 -39 54 -54 81 -15 28 -35 64 -44 80 -22 39 -34 136 -20
150 8 8 21 0 46 -26 20 -20 36 -41 36 -46 0 -5 18 -21 41 -35 37 -24 40 -29
33 -58 -6 -27 -6 -107 -2 -179 2 -30 18 -42 103 -83 43 -20 98 -37 139 -43
l69 -9 38 37 c51 50 157 104 249 128 47 12 78 26 85 38 5 10 18 27 27 38 10
11 25 40 34 65 10 25 21 50 26 56 11 13 10 178 -2 209 -13 36 -28 32 -36 -9
-8 -42 -19 -45 -29 -7 -9 38 -44 72 -73 72 -21 0 -22 -2 -12 -15 16 -19 -8
-58 -53 -85 l-32 -20 28 0 c16 0 27 -5 27 -14 0 -15 -48 -89 -61 -94 -5 -2 -9
-23 -9 -46 0 -30 -6 -48 -20 -61 -11 -10 -20 -26 -20 -35 0 -25 -66 -92 -87
-88 -27 5 -57 75 -55 126 1 24 -5 57 -13 72 -8 16 -15 38 -15 49 0 24 -25 33
-83 31 -70 -3 -75 -1 -96 33 -25 40 -21 109 7 141 29 32 44 65 37 85 -8 25 4
51 28 60 19 7 19 8 -5 34 -19 21 -27 24 -37 14 -9 -9 -14 -9 -21 3 -5 8 -10
11 -10 6 0 -5 -6 -4 -13 3 -10 8 -17 7 -25 -1z m478 -537 c0 -5 -7 -14 -15
-21 -16 -14 -18 -10 -9 14 6 17 24 22 24 7z"/>
<path d="M1290 3641 c-183 -25 -265 -168 -364 -631 -31 -145 -45 -224 -41
-229 3 -2 33 16 67 40 147 103 282 176 361 195 27 6 26 3 -35 -90 -182 -280
-230 -368 -283 -515 -99 -273 -13 -479 255 -612 95 -47 81 -69 135 221 8 41
27 147 44 235 16 88 42 223 56 300 14 77 29 143 34 148 8 8 131 -116 251 -253
41 -47 77 -87 80 -90 3 -3 34 -39 70 -80 123 -143 154 -175 275 -295 131 -129
210 -183 336 -231 65 -24 88 -28 191 -28 113 -1 117 0 160 29 77 54 73 37 228
865 81 434 120 661 120 705 0 15 -5 25 -12 24 -7 -2 -30 5 -52 14 -21 9 -45
17 -53 17 -7 0 -16 6 -19 14 -3 8 -29 27 -57 41 -29 15 -59 34 -67 44 -9 10
-22 20 -29 22 -19 7 -25 50 -9 61 9 6 6 7 -8 3 -14 -4 -24 0 -27 10 -4 9 -13
12 -24 9 -15 -5 -15 -4 -3 5 8 5 12 13 8 16 -10 11 -69 -22 -134 -74 l-60 -48
-18 -94 c-18 -96 -73 -406 -101 -579 -9 -52 -23 -135 -31 -183 -15 -88 -14
-98 16 -127 3 -3 21 -25 40 -50 40 -51 80 -97 165 -189 37 -40 49 -57 30 -44
-47 33 -132 127 -242 268 -56 72 -112 142 -125 157 -13 14 -44 54 -69 88 -24
35 -61 81 -81 103 -21 23 -38 47 -38 54 0 8 -11 18 -24 24 -14 7 -22 17 -19
25 3 8 -1 14 -11 14 -10 0 -13 6 -10 15 4 9 0 15 -10 15 -9 0 -16 7 -16 15 0
8 -4 15 -10 15 -5 0 -10 6 -10 14 0 7 -7 19 -15 26 -18 15 -20 0 -2 -20 10
-12 9 -12 -6 0 -10 7 -16 21 -14 31 3 11 0 16 -8 12 -8 -2 -23 0 -34 7 -16 8
-21 8 -21 -1 0 -6 -7 -8 -16 -5 -8 3 -13 2 -10 -3 3 -5 -12 -11 -34 -15 -22
-3 -40 -11 -40 -16 0 -6 -18 -10 -40 -10 -29 0 -40 -4 -40 -15 0 -9 -6 -12
-15 -9 -8 4 -15 1 -15 -6 0 -7 -7 -10 -15 -6 -17 6 -115 -16 -115 -26 0 -5
-18 -8 -39 -8 -44 0 -59 -13 -41 -35 21 -25 -13 -18 -42 8 -107 97 -193 164
-244 194 -31 18 -35 22 -18 23 12 0 24 -7 28 -15 3 -8 13 -15 21 -15 9 0 13 4
10 10 -3 5 0 7 8 5 24 -10 66 38 76 85 15 77 49 140 108 199 41 41 56 63 56
84 0 27 11 35 22 17 7 -12 25 -13 25 -2 0 6 -19 19 -109 73 -70 41 -169 61
-251 50z"/>
<path d="M2570 3640 c-8 -5 -12 -11 -10 -14 3 -2 14 2 24 10 22 15 10 19 -14
4z"/>
<path d="M5560 3600 c0 -5 12 -10 26 -10 14 0 23 4 19 10 -3 6 -15 10 -26 10
-10 0 -19 -4 -19 -10z"/>
<path d="M5403 3583 c-25 -9 -14 -33 15 -33 15 0 35 -9 44 -19 21 -25 138 -30
138 -6 0 8 -10 16 -22 17 -13 1 -30 2 -39 3 -9 0 -24 6 -32 13 -10 9 -17 10
-22 2 -9 -15 -25 -12 -25 5 0 8 -4 15 -9 15 -5 0 -15 2 -23 4 -7 3 -19 2 -25
-1z"/>
<path d="M5680 3576 c0 -8 5 -18 10 -21 6 -3 10 1 10 9 0 8 -4 18 -10 21 -5 3
-10 -1 -10 -9z"/>
<path d="M5706 3475 c4 -8 12 -15 20 -15 19 0 18 16 -2 24 -22 9 -24 8 -18 -9z"/>
<path d="M5630 3443 c0 -21 22 -62 36 -67 20 -7 18 0 -11 42 -14 20 -25 31
-25 25z"/>
<path d="M5927 3382 c6 -81 11 -87 12 -15 1 34 -3 64 -7 67 -5 3 -7 -21 -5
-52z"/>
<path d="M3231 3374 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1960 3216 c0 -4 11 -21 25 -38 14 -16 25 -25 25 -20 0 5 -11 22 -25
38 -14 16 -25 25 -25 20z"/>
<path d="M2042 3110 c7 -10 14 -18 15 -16 6 6 -9 36 -18 36 -5 0 -4 -9 3 -20z"/>
<path d="M3837 2874 c-4 -4 -7 -259 -7 -566 l0 -558 125 0 125 0 0 29 c0 39
13 46 36 20 62 -68 188 -85 280 -36 120 62 188 209 186 406 -2 219 -80 369
-221 422 -49 19 -63 20 -115 10 -55 -10 -136 -53 -136 -72 0 -5 -4 -9 -10 -9
-6 0 -11 70 -12 178 l-3 177 -121 3 c-66 1 -123 -1 -127 -4z m437 -553 c45
-40 67 -143 46 -220 -18 -66 -57 -101 -115 -101 -38 0 -52 5 -75 28 -78 78
-60 259 30 305 39 19 83 15 114 -12z"/>
<path d="M4825 2605 c-33 -7 -80 -21 -104 -30 l-43 -18 7 -106 c4 -58 8 -107
9 -108 2 -2 36 8 76 22 76 26 160 32 203 16 37 -14 67 -51 67 -83 0 -26 -2
-28 -27 -21 -16 5 -73 8 -128 8 -83 0 -107 -4 -140 -22 -91 -49 -140 -135
-140 -248 0 -90 16 -141 60 -192 38 -45 120 -83 179 -83 49 0 132 28 164 55
17 14 33 25 36 25 3 0 6 -16 6 -35 l0 -36 123 3 122 3 3 293 c2 287 2 294 -22
363 -29 84 -65 129 -131 163 -88 46 -203 57 -320 31z m216 -506 c5 -8 8 -32 5
-53 -6 -54 -42 -87 -99 -93 -39 -5 -49 -2 -71 20 -41 41 -32 116 17 137 33 14
137 6 148 -11z"/>
<path d="M3290 2589 c-41 -10 -88 -24 -104 -31 l-29 -12 7 -105 c4 -58 8 -106
9 -107 1 -1 35 9 76 22 158 52 281 18 281 -78 0 -15 -4 -18 -17 -13 -39 15
-141 26 -188 20 -157 -21 -245 -120 -245 -275 0 -129 62 -225 164 -255 92 -28
182 -13 253 41 l33 25 0 -36 0 -36 126 3 125 3 -1 294 c0 184 -5 312 -12 340
-13 51 -49 115 -82 143 -86 75 -243 97 -396 57z m226 -486 c9 -3 14 -21 14
-50 0 -36 -6 -50 -30 -75 -29 -28 -35 -30 -86 -26 -62 5 -83 24 -84 74 0 37
31 81 63 87 23 5 100 -1 123 -10z"/>
<path d="M9654 2135 c3 -100 7 -128 26 -169 31 -64 88 -121 147 -148 67 -29
183 -35 256 -14 l57 17 0 110 c0 110 0 111 -22 106 -73 -17 -117 -18 -146 -3
-17 9 -33 20 -36 25 -7 11 -26 98 -32 151 -6 39 -14 54 -14 23 0 -29 -11 -35
-26 -15 -11 14 -13 15 -14 2 0 -12 -9 -15 -37 -12 -21 2 -45 6 -53 10 -25 10
-90 8 -91 -3 -1 -5 -5 1 -10 15 -5 16 -7 -18 -5 -95z"/>
<path d="M5606 2205 c-3 -9 -6 -22 -5 -28 0 -7 5 -1 10 12 5 13 8 26 5 28 -2
2 -6 -3 -10 -12z"/>
<path d="M5399 2168 c-2 -31 -2 -31 -6 -5 -2 15 -9 27 -15 27 -18 0 12 -138
49 -221 9 -22 20 -39 25 -39 4 0 8 -7 8 -16 0 -30 115 -133 187 -166 62 -28
77 -31 173 -32 112 -1 159 11 248 62 l43 25 -2 121 c-1 66 -4 126 -6 133 -5
13 -38 1 -83 -29 -14 -9 -52 -24 -85 -33 -64 -17 -113 -13 -173 12 -38 16
-102 78 -102 99 0 16 -37 37 -50 29 -6 -3 -10 1 -10 9 0 12 -10 16 -40 16 -22
0 -40 4 -40 9 0 13 -89 18 -94 6 -3 -5 -5 -2 -5 8 -2 31 -21 18 -22 -15z"/>
<path d="M5621 2164 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7531 2125 l-1 -40 -82 -2 c-57 -2 -84 1 -90 10 -5 7 -8 -2 -8 -23
l-1 -35 -14 30 c-12 27 -13 13 -14 -138 l-1 -168 113 3 112 3 3 55 c1 30 -2
120 -6 200 -5 80 -10 127 -11 105z"/>
<path d="M6911 1953 l-1 -193 110 0 110 0 -1 183 c-1 100 -3 175 -6 166 -5
-20 -69 -37 -110 -28 -37 7 -49 2 -56 -26 -2 -11 -6 3 -7 30 l-3 50 -7 -50
c-6 -44 -7 -46 -9 -15 -1 19 -6 44 -11 55 -5 12 -9 -56 -9 -172z"/>
<path d="M7641 2085 c-1 -16 -3 -17 -10 -6 -11 17 -24 -147 -19 -239 3 -64 4
-65 33 -68 17 -2 67 -1 113 3 l82 7 0 131 c0 73 -4 138 -9 146 -12 18 -151 25
-152 7 0 -6 -4 -2 -9 9 -8 18 -9 18 -10 -5 -2 -24 -3 -23 -10 5 -5 20 -8 24
-9 10z"/>
<path d="M8508 2093 c-10 -3 -18 -14 -18 -26 0 -18 -2 -19 -10 -7 -8 12 -13
13 -27 2 -10 -7 -26 -15 -35 -18 -10 -4 -18 -11 -18 -18 0 -6 -5 -4 -10 4 -9
13 -11 13 -20 0 -6 -10 -10 -11 -10 -2 0 6 -4 12 -9 12 -20 0 22 -89 65 -138
63 -71 134 -104 234 -110 88 -5 162 9 233 45 53 27 54 28 36 147 l-11 74 -32
-17 c-103 -57 -273 -51 -316 10 -29 40 -35 46 -52 42z m22 -45 c0 -5 -4 -8
-10 -8 -5 0 -10 10 -10 23 0 18 2 19 10 7 5 -8 10 -18 10 -22z"/>
<path d="M9211 2084 c-16 -8 -31 -10 -42 -3 -19 10 -49 2 -49 -13 0 -5 -8 -7
-17 -4 -10 3 -28 0 -40 -7 l-22 -12 23 -52 c57 -123 167 -194 298 -192 42 0
94 8 123 18 l50 18 3 118 c2 109 1 117 -15 110 -109 -47 -195 -44 -244 7 -29
31 -29 31 -30 7 -1 -22 -2 -22 -7 -4 -6 19 -10 20 -31 9z"/>
<path d="M6371 2065 c-1 -17 -3 -17 -11 -5 -8 13 -10 12 -10 -2 0 -19 -26 -25
-32 -8 -5 16 -76 21 -82 5 -3 -8 -23 -15 -45 -17 l-41 -3 15 -29 c8 -15 15
-35 15 -42 0 -29 49 -110 92 -151 162 -157 422 -109 526 99 33 65 51 130 36
127 -5 -1 -13 0 -19 1 -5 1 -26 1 -46 0 -21 -1 -40 3 -44 9 -3 6 -11 11 -16
11 -6 0 -8 -4 -5 -9 8 -13 -47 -21 -62 -9 -9 8 -11 7 -6 -6 3 -9 1 -16 -5 -16
-6 0 -11 8 -11 18 -1 15 -2 15 -15 -3 -41 -55 -57 -65 -104 -65 -40 0 -52 5
-76 30 -16 17 -35 43 -41 58 -10 22 -13 24 -13 7z"/>
<path d="M8026 1941 c-4 -77 -5 -145 -1 -151 7 -11 60 -13 158 -3 l68 6 -2
141 -2 141 -44 -2 c-24 0 -47 -3 -50 -6 -3 -3 -16 -2 -29 3 -17 7 -27 5 -38
-5 -19 -19 -33 -19 -44 1 -6 11 -12 -32 -16 -125z"/>
<path d="M9063 1733 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"/>
<path d="M9153 1733 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M9243 1733 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M9483 1733 c26 -2 67 -2 90 0 23 2 2 3 -48 3 -49 0 -68 -1 -42 -3z"/>
<path d="M9783 1733 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"/>
<path d="M8510 1723 c-14 -3 -28 -10 -32 -17 -6 -8 -8 -8 -8 2 0 6 -7 12 -16
12 -8 0 -12 -4 -9 -10 3 -5 0 -10 -9 -10 -8 0 -16 4 -18 9 -3 10 -375 -13
-453 -27 -46 -9 -61 -38 -23 -47 13 -3 84 -1 158 4 74 5 140 6 147 4 7 -3 13
-16 13 -29 0 -33 -22 -40 -150 -49 -58 -4 -109 -10 -115 -15 -11 -8 -252 -40
-307 -40 -57 0 -108 -19 -108 -39 0 -27 13 -29 120 -20 88 7 146 13 369 40 72
9 86 8 100 -6 12 -12 13 -19 5 -33 -13 -20 -73 -30 -192 -31 -90 -1 -122 -11
-122 -40 0 -27 31 -32 195 -30 148 1 165 -2 165 -26 0 -26 -38 -35 -147 -35
-132 0 -153 -5 -153 -35 0 -20 6 -24 48 -28 78 -9 1923 -29 1980 -22 100 12
156 78 218 256 37 106 41 160 16 201 -31 51 -67 66 -134 61 -32 -3 -58 -9 -58
-13 0 -8 -37 -6 -69 5 -13 4 -28 1 -37 -5 -8 -7 -28 -14 -45 -16 -24 -3 -30
-1 -25 11 3 9 0 15 -10 15 -8 0 -13 -4 -10 -9 8 -12 -82 -13 -104 -1 -13 7
-20 5 -24 -6 -5 -12 -10 -13 -19 -6 -14 12 -374 19 -384 8 -3 -3 -16 -3 -28 0
-13 3 -28 -1 -38 -10 -20 -20 -33 -21 -17 -1 7 9 9 19 5 23 -4 4 -10 1 -12 -6
-3 -6 -10 -9 -16 -5 -6 4 -52 8 -102 10 -366 14 -397 14 -390 4 4 -8 -13 -10
-52 -9 l-58 1 50 7 50 7 -60 0 c-33 0 -71 -2 -85 -4z m237 -9 c-3 -3 -12 -4
-19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m293 -24 c0 -5 -5 -10 -11 -10 -5 0
-7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m480 0 c0 -6 -39 -10 -97 -9 -64 0
-91 3 -78 9 28 12 175 12 175 0z m-744 -50 c10 -8 22 -19 26 -25 23 -30 -13
-200 -53 -255 -43 -58 -67 -64 -248 -68 -90 -2 -167 0 -172 5 -7 7 68 335 83
358 10 17 341 3 364 -15z m382 18 c5 -7 13 -35 17 -63 4 -27 18 -98 31 -157
35 -154 36 -148 -36 -148 -59 0 -60 0 -68 33 l-8 32 -85 3 -85 3 -32 -36 c-29
-32 -38 -35 -86 -35 -29 0 -55 3 -59 6 -3 3 13 32 36 65 23 32 80 112 127 178
l85 120 70 4 c39 1 73 4 76 5 4 1 11 -4 17 -10z m502 -13 c0 -19 -22 -79 -32
-86 -5 -3 -34 -7 -66 -8 -31 -1 -60 -6 -65 -10 -4 -4 -22 -61 -41 -127 l-33
-119 -58 -3 -58 -3 7 48 c3 26 15 77 26 111 29 91 27 102 -15 103 -19 1 -39 3
-45 4 -5 1 -17 3 -26 4 -12 1 -14 11 -11 49 l4 47 194 5 c207 5 219 5 219 -15z
m274 3 c6 -25 67 -343 66 -350 0 -5 -27 -8 -60 -8 -59 0 -60 0 -68 33 l-8 32
-92 3 c-51 1 -92 -1 -92 -5 0 -5 -11 -21 -25 -36 -22 -23 -34 -27 -80 -27 -39
0 -55 4 -55 13 0 7 30 54 66 103 36 49 72 98 79 109 8 11 35 48 60 83 l45 62
80 0 c56 0 82 -4 84 -12z"/>
<path d="M8495 1504 c-8 -29 -18 -68 -22 -85 l-6 -31 81 3 c67 3 84 8 96 24
20 27 41 114 30 125 -5 4 -44 10 -86 13 l-77 5 -16 -54z"/>
<path d="M9023 1510 c-41 -51 -40 -60 7 -60 39 0 42 2 36 23 -3 12 -6 32 -6
45 0 29 -10 27 -37 -8z"/>
<path d="M9795 1510 c-11 -16 -23 -30 -27 -30 -5 0 -8 -7 -8 -15 0 -11 11 -15
40 -15 35 0 40 3 40 23 0 29 -11 67 -19 67 -3 0 -15 -14 -26 -30z"/>
<path d="M7794 1665 c-8 -20 4 -35 29 -35 31 0 51 15 44 34 -8 20 -65 22 -73
1z"/>
<path d="M3015 1624 c-392 -69 -583 -87 -947 -88 -170 0 -308 -3 -308 -7 0 -3
-18 -5 -40 -4 -33 2 -40 -1 -40 -17 0 -13 -7 -18 -29 -18 -16 0 -43 -3 -60 -6
-27 -6 -31 -11 -31 -38 0 -49 11 -57 76 -57 32 0 85 -2 117 -5 67 -7 398 12
479 26 29 5 112 19 183 31 157 25 427 93 596 150 68 23 126 43 128 45 8 7 -42
2 -124 -12z m-1178 -100 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M1588 1563 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7444 1485 c-19 -15 -19 -15 1 -30 33 -26 94 -3 82 29 -8 20 -57 21
-83 1z"/>
<path d="M1460 1432 c0 -15 24 -32 45 -32 19 0 18 2 -5 20 -27 21 -40 25 -40
12z"/>
<path d="M7780 1275 c-29 -35 43 -62 85 -31 16 12 17 16 6 30 -17 20 -75 21
-91 1z"/>
<path d="M5240 1065 c0 -108 1 -115 20 -115 19 0 20 7 20 115 0 108 -1 115
-20 115 -19 0 -20 -7 -20 -115z"/>
<path d="M6340 1065 c0 -108 1 -115 20 -115 17 0 20 7 20 53 0 63 10 80 41 75
22 -3 24 -8 27 -65 3 -59 4 -63 27 -63 23 0 25 4 25 43 0 68 -17 116 -45 123
-13 3 -32 1 -43 -5 -30 -16 -32 -15 -32 29 0 33 -3 40 -20 40 -19 0 -20 -7
-20 -115z"/>
<path d="M2754 1136 c-29 -29 -34 -41 -34 -83 0 -41 5 -54 29 -77 37 -35 96
-44 139 -22 36 19 35 53 -2 41 -58 -19 -75 -17 -100 8 -14 15 -26 36 -26 47 0
24 18 61 34 72 16 11 74 10 81 -2 4 -7 14 -6 28 1 l21 12 -23 18 c-15 12 -39
19 -68 19 -38 0 -50 -5 -79 -34z"/>
<path d="M4387 1163 c-4 -3 -7 -53 -7 -110 0 -96 1 -103 20 -103 16 0 20 7 20
30 0 25 4 30 25 30 38 0 92 26 105 50 17 32 3 78 -30 95 -29 15 -121 21 -133
8z m118 -67 c0 -23 -6 -31 -28 -39 -39 -13 -57 -3 -57 31 0 38 7 44 50 40 31
-3 35 -6 35 -32z"/>
<path d="M5627 1164 c-18 -18 -5 -34 28 -34 l35 0 0 -90 c0 -89 0 -90 25 -90
25 0 25 1 25 90 l0 90 36 0 c28 0 35 3 32 18 -3 14 -17 17 -89 20 -47 1 -88 0
-92 -4z"/>
<path d="M6120 1151 c0 -15 8 -20 33 -23 l32 -3 5 -88 c3 -48 8 -87 13 -87 4
0 11 0 17 0 5 0 11 39 12 88 l3 87 33 3 c25 3 32 8 30 20 -3 14 -18 17 -91 20
-81 3 -87 1 -87 -17z"/>
<path d="M6857 1163 c-4 -3 -7 -53 -7 -110 0 -96 1 -103 20 -103 19 0 20 7 20
110 0 85 -3 110 -13 110 -8 0 -17 -3 -20 -7z"/>
<path d="M3980 1145 c0 -8 -6 -25 -12 -36 -10 -17 -10 -23 0 -26 7 -3 12 -25
12 -59 0 -46 4 -56 25 -70 27 -18 65 -11 65 12 0 8 -9 14 -20 14 -17 0 -20 7
-20 50 0 43 3 50 20 50 12 0 20 7 20 16 0 9 -9 18 -20 21 -11 3 -20 14 -20 24
0 14 -7 19 -25 19 -16 0 -25 -6 -25 -15z"/>
<path d="M7160 1145 c0 -8 -6 -25 -12 -36 -10 -17 -10 -23 0 -26 7 -3 12 -21
12 -43 0 -73 30 -111 74 -94 23 9 20 34 -4 34 -17 0 -20 7 -20 50 0 44 3 50
21 50 14 0 19 5 17 18 -2 9 -10 17 -18 17 -8 0 -16 10 -18 23 -3 16 -10 22
-28 22 -15 0 -24 -6 -24 -15z"/>
<path d="M8040 1145 c0 -8 -6 -25 -12 -36 -10 -17 -10 -23 0 -26 8 -3 12 -26
12 -64 0 -54 2 -60 26 -71 18 -8 31 -9 42 -2 25 16 25 32 0 36 -20 3 -23 10
-26 51 -3 41 -1 47 17 47 31 0 35 19 7 32 -14 6 -26 19 -26 30 0 11 -7 18 -20
18 -11 0 -20 -7 -20 -15z"/>
<path d="M2979 1091 c-74 -74 15 -186 109 -137 35 18 42 33 42 87 0 34 -5 42
-32 59 -47 28 -84 26 -119 -9z m100 -25 c16 -19 10 -66 -10 -79 -44 -28 -95
25 -69 72 13 25 61 29 79 7z"/>
<path d="M3187 1113 c-4 -3 -7 -42 -7 -85 0 -71 2 -78 20 -78 17 0 20 7 20 49
0 64 7 81 35 81 28 0 35 -17 35 -81 0 -42 3 -49 20 -49 18 0 20 7 20 68 0 54
-4 72 -18 85 -21 19 -45 21 -72 7 -13 -7 -21 -7 -25 0 -7 12 -19 13 -28 3z"/>
<path d="M3387 1114 c-4 -4 -7 -43 -7 -86 0 -71 2 -78 20 -78 16 0 20 7 21 38
1 20 1 41 0 45 -3 21 22 48 42 45 19 -3 23 -11 27 -63 4 -52 8 -60 25 -60 18
0 20 8 23 62 2 52 0 65 -19 84 -15 15 -28 19 -47 15 -37 -9 -45 -9 -63 -2 -8
4 -18 3 -22 0z"/>
<path d="M3608 1097 c-34 -30 -38 -89 -8 -127 15 -20 28 -25 64 -25 49 0 78
17 59 36 -8 8 -17 8 -30 1 -14 -8 -26 -7 -43 1 -37 19 -24 32 35 35 50 3 55 5
55 26 0 63 -83 96 -132 53z m82 -21 c0 -2 3 -11 6 -20 5 -13 -2 -16 -35 -16
-44 0 -44 0 -35 24 5 14 64 24 64 12z"/>
<path d="M3811 1094 c-25 -20 -31 -34 -31 -64 0 -67 83 -114 135 -77 28 21 10
39 -31 31 -42 -8 -64 8 -64 46 0 38 22 54 64 46 41 -8 59 10 31 31 -29 20 -70
16 -104 -13z"/>
<path d="M4138 1113 c-20 -5 -34 -44 -25 -68 4 -8 22 -21 42 -29 52 -22 43
-56 -10 -36 -31 12 -47 6 -39 -15 8 -20 63 -29 97 -16 21 8 27 17 27 40 0 32
-13 46 -52 56 -15 4 -29 13 -32 21 -4 11 4 14 34 14 27 0 40 4 40 14 0 20 -41
30 -82 19z"/>
<path d="M4632 1110 c-28 -12 -55 -73 -46 -103 17 -56 83 -83 129 -53 30 20
24 40 -8 30 -31 -10 -59 -7 -68 8 -13 20 1 29 36 22 46 -8 75 3 75 29 -1 52
-66 89 -118 67z m68 -34 c0 -2 3 -11 6 -20 5 -13 -2 -16 -35 -16 -39 0 -53 14
-34 33 7 8 63 10 63 3z"/>
<path d="M4823 1101 c-22 -14 -34 -31 -38 -54 -8 -43 6 -72 47 -93 67 -35 146
15 134 85 -11 69 -82 100 -143 62z m96 -47 c10 -22 9 -31 -4 -50 -28 -43 -85
-26 -85 26 0 33 17 50 50 50 19 0 30 -8 39 -26z"/>
<path d="M5017 1114 c-4 -4 -7 -56 -7 -116 0 -100 1 -108 19 -108 15 0 21 8
23 33 2 23 7 31 18 27 8 -2 30 -4 49 -4 46 1 71 33 71 89 0 37 -5 47 -31 65
-21 16 -38 20 -57 16 -37 -9 -45 -9 -63 -2 -8 4 -18 3 -22 0z m125 -59 c17
-39 -3 -75 -42 -75 -23 0 -33 6 -42 25 -17 39 3 75 42 75 23 0 33 -6 42 -25z"/>
<path d="M5355 1098 c-36 -32 -43 -85 -15 -120 28 -36 81 -46 116 -23 33 22
19 40 -20 25 -19 -7 -33 -7 -47 1 -35 18 -16 34 41 34 60 0 69 10 50 54 -21
51 -82 65 -125 29z m83 -40 c3 -15 -4 -18 -32 -18 -34 0 -47 15 -29 34 13 13
58 1 61 -16z"/>
<path d="M5850 1108 c-49 -26 -63 -88 -30 -131 39 -50 131 -41 161 14 14 27 4
82 -20 103 -25 23 -81 30 -111 14z m78 -40 c7 -7 12 -24 12 -38 0 -33 -17 -50
-51 -50 -28 0 -39 15 -39 54 0 28 18 46 45 46 12 0 26 -5 33 -12z"/>
<path d="M6563 1096 c-22 -20 -28 -32 -27 -65 1 -24 9 -50 19 -61 26 -29 79
-36 111 -15 33 21 24 30 -34 30 -35 0 -47 4 -47 15 0 12 13 15 55 15 46 0 55
3 58 19 8 40 -38 86 -88 86 -10 0 -31 -11 -47 -24z m90 -30 c8 -20 -2 -26 -40
-26 -31 0 -44 16 -26 33 12 13 61 7 66 -7z"/>
<path d="M7026 1113 c-4 -4 -22 -6 -41 -5 l-35 3 0 -81 c0 -73 2 -80 20 -80
17 0 20 7 20 46 0 57 14 84 44 84 27 0 36 -21 36 -87 0 -36 3 -43 20 -43 18 0
20 7 20 65 0 52 -4 69 -20 85 -20 20 -50 26 -64 13z"/>
<path d="M7309 1091 c-20 -20 -29 -39 -29 -61 0 -65 85 -113 135 -77 26 20 11
39 -21 27 -17 -7 -32 -6 -45 1 -34 18 -16 34 42 35 53 1 54 2 52 30 -3 35 -44
74 -79 74 -15 0 -38 -12 -55 -29z m89 -33 c3 -15 -4 -18 -32 -18 -34 0 -47 15
-29 34 13 13 58 1 61 -16z"/>
<path d="M7497 1113 c-4 -3 -7 -42 -7 -85 0 -71 2 -78 20 -78 17 0 20 7 20 45
0 33 6 50 22 65 12 11 25 20 30 20 4 0 8 9 8 20 0 23 -4 24 -32 9 -14 -8 -23
-8 -31 0 -13 13 -21 14 -30 4z"/>
<path d="M7635 1110 c-9 -15 -14 -109 -8 -137 3 -14 13 -23 24 -23 15 0 18 10
21 63 3 57 5 62 27 65 31 5 41 -12 41 -75 0 -46 3 -53 20 -53 18 0 20 7 20 70
0 63 -2 71 -25 86 -19 12 -31 14 -53 6 -17 -6 -35 -6 -45 -1 -10 6 -18 5 -22
-1z"/>
<path d="M7855 1098 c-15 -14 -28 -38 -32 -60 -5 -32 -1 -41 25 -68 32 -31 68
-38 103 -20 10 6 19 17 19 25 0 18 -1 18 -35 5 -30 -11 -69 3 -62 23 4 12 11
13 85 16 26 1 32 5 32 24 -1 26 -17 49 -47 65 -33 18 -59 15 -88 -10z m84 -31
c15 -19 4 -27 -36 -27 -31 0 -44 16 -26 33 11 12 50 8 62 -6z"/>
<path d="M2656 664 c-44 -13 -81 -25 -82 -27 -10 -10 18 -181 35 -215 22 -44
93 -110 127 -118 29 -7 117 52 150 99 30 44 46 117 42 188 l-3 53 -70 19
c-103 28 -113 28 -199 1z m183 -30 l63 -18 -4 -70 c-6 -90 -36 -155 -88 -191
-50 -35 -81 -28 -136 29 -47 50 -67 107 -62 186 l3 54 58 12 c32 6 61 14 65
18 3 4 13 5 22 3 8 -3 44 -13 79 -23z"/>
<path d="M2740 622 c0 -5 -22 -13 -50 -17 l-50 -7 0 -42 c0 -66 27 -132 68
-166 20 -17 41 -30 47 -30 19 0 83 60 100 93 9 17 18 57 22 89 l6 57 -40 10
c-74 20 -103 24 -103 13z"/>
<path d="M6723 658 c-28 -32 -34 -54 -22 -85 26 -68 103 -71 137 -6 18 34 14
62 -13 88 -31 32 -75 33 -102 3z"/>
<path d="M4326 663 c-10 -10 -6 -353 5 -353 5 0 9 76 9 180 0 99 -1 180 -3
180 -2 0 -7 -3 -11 -7z"/>
<path d="M6190 490 c0 -113 4 -180 10 -180 6 0 10 67 10 180 0 113 -4 180 -10
180 -6 0 -10 -67 -10 -180z"/>
<path d="M6556 594 c-43 -42 4 -120 56 -93 44 23 50 57 16 89 -26 24 -51 26
-72 4z"/>
<path d="M6917 592 c-24 -26 -21 -68 5 -86 30 -21 44 -20 68 4 26 26 25 50 0
78 -25 27 -51 28 -73 4z"/>
<path d="M3600 585 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0
-15 -7 -15 -15z"/>
<path d="M3990 586 c0 -10 9 -16 21 -16 24 0 21 23 -4 28 -10 2 -17 -3 -17
-12z"/>
<path d="M5870 585 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0
-15 -7 -15 -15z"/>
<path d="M7657 593 c-4 -3 -7 -17 -7 -30 0 -22 -3 -23 -34 -18 -28 6 -36 3
-55 -21 -28 -36 -24 -81 9 -105 20 -15 34 -17 70 -11 l45 8 1 79 c1 98 -6 122
-29 98z m-19 -85 c18 -18 15 -65 -4 -72 -42 -16 -75 24 -54 64 12 22 40 26 58
8z"/>
<path d="M7730 586 c0 -9 7 -16 16 -16 9 0 14 5 12 12 -6 18 -28 21 -28 4z"/>
<path d="M8395 590 c-3 -6 1 -13 10 -16 19 -8 30 0 20 15 -8 14 -22 14 -30 1z"/>
<path d="M3191 567 c-5 -13 -23 -53 -39 -90 -28 -60 -29 -67 -13 -67 10 0 21
9 24 20 4 16 14 20 51 20 35 0 48 -4 56 -20 10 -19 40 -28 40 -12 0 5 -13 35
-29 68 -15 32 -31 69 -35 82 -10 29 -44 29 -55 -1z m43 -43 c12 -31 6 -44 -19
-44 -28 0 -28 0 -15 34 11 29 25 34 34 10z"/>
<path d="M5281 576 c-7 -8 -11 -27 -9 -43 2 -23 11 -31 48 -44 47 -17 64 -44
34 -56 -9 -3 -30 -1 -47 5 -35 13 -53 6 -36 -14 19 -23 76 -28 105 -9 41 27
30 65 -28 93 -62 29 -65 55 -6 50 45 -3 64 15 26 26 -39 10 -75 7 -87 -8z"/>
<path d="M7190 500 c0 -72 3 -90 14 -90 10 0 16 13 18 38 3 36 4 37 46 38 37
1 42 -1 43 -22 3 -45 4 -49 22 -52 15 -3 17 6 17 88 0 82 -2 91 -17 88 -18 -3
-19 -7 -22 -52 -1 -21 -6 -23 -43 -22 -42 1 -43 2 -46 39 -2 24 -8 37 -18 37
-11 0 -14 -18 -14 -90z"/>
<path d="M8052 498 c2 -56 7 -92 13 -91 6 1 11 13 13 27 2 13 10 30 19 37 13
11 20 7 50 -29 19 -23 39 -42 44 -42 18 0 9 26 -21 60 -37 45 -37 57 2 97 25
26 28 33 15 33 -10 0 -37 -19 -60 -42 l-42 -43 -3 43 c-2 29 -8 42 -18 42 -12
0 -14 -16 -12 -92z"/>
<path d="M3345 542 c-3 -3 -5 -34 -5 -69 0 -56 2 -63 19 -63 17 0 20 8 23 53
3 45 6 52 25 55 24 4 30 -10 35 -78 4 -54 22 -41 28 20 5 51 7 55 30 55 23 0
25 -4 30 -55 6 -70 24 -71 28 -3 4 72 -10 97 -51 89 -18 -4 -36 -6 -42 -6 -5
0 -34 2 -62 4 -29 1 -55 0 -58 -2z"/>
<path d="M3607 543 c-4 -3 -7 -35 -7 -70 0 -49 3 -63 15 -63 12 0 15 14 15 70
0 64 -6 81 -23 63z"/>
<path d="M3674 524 c-10 -40 0 -109 16 -109 11 0 16 14 20 50 5 45 7 50 30 50
23 0 25 -4 28 -52 2 -38 7 -53 18 -53 19 0 20 113 1 128 -7 6 -34 10 -60 9
-39 -2 -49 -6 -53 -23z"/>
<path d="M3869 535 c-29 -16 -42 -56 -29 -90 12 -31 59 -49 93 -36 39 15 33
31 -9 28 -43 -2 -60 17 -50 58 6 25 10 27 41 22 40 -7 55 7 26 22 -26 14 -40
13 -72 -4z"/>
<path d="M3997 544 c-4 -4 -7 -35 -7 -70 0 -46 4 -63 15 -68 21 -8 27 11 23
79 -3 54 -14 75 -31 59z"/>
<path d="M5458 543 c-30 -8 -20 -22 19 -25 48 -4 57 -28 11 -28 -40 0 -58 -15
-58 -47 0 -31 29 -44 81 -35 47 8 45 2 40 86 -2 45 -37 64 -93 49z m60 -90
c-4 -22 -58 -31 -58 -10 0 20 10 27 37 27 18 0 24 -5 21 -17z"/>
<path d="M5597 543 c-10 -10 -8 -106 2 -122 6 -10 28 -15 63 -15 l53 0 0 67
c0 77 -17 91 -25 21 -10 -91 -70 -80 -70 13 0 40 -8 52 -23 36z"/>
<path d="M5760 480 c0 -56 3 -70 15 -70 11 0 15 11 15 40 0 31 5 43 25 56 14
9 25 23 25 30 0 17 -12 18 -28 2 -9 -9 -15 -9 -24 0 -23 23 -28 12 -28 -58z"/>
<path d="M5876 543 c-3 -3 -6 -35 -6 -70 0 -49 3 -63 15 -63 12 0 15 14 15 64
0 60 -8 84 -24 69z"/>
<path d="M7413 543 c-25 -9 -13 -22 24 -25 49 -4 57 -28 10 -28 -51 0 -80 -34
-59 -68 9 -13 33 -17 90 -14 32 2 32 2 32 56 0 45 -4 58 -22 70 -22 16 -51 19
-75 9z m62 -93 c0 -16 -28 -25 -50 -16 -9 3 -12 12 -9 21 8 21 59 16 59 -5z"/>
<path d="M7729 546 c-2 -2 -2 -34 -1 -70 3 -50 7 -66 18 -66 12 0 14 14 12 67
-3 58 -14 84 -29 69z"/>
<path d="M7807 544 c-4 -4 -7 -35 -7 -70 0 -46 4 -63 15 -68 12 -4 15 4 15 38
0 57 8 76 30 76 26 0 33 -16 31 -67 -1 -32 3 -43 13 -43 23 0 28 17 21 75 -6
46 -11 56 -30 61 -13 3 -32 1 -43 -5 -12 -6 -22 -7 -29 0 -5 5 -12 6 -16 3z"/>
<path d="M8258 543 c-30 -8 -20 -22 19 -25 48 -4 57 -28 11 -28 -19 0 -39 -5
-46 -12 -16 -16 -15 -55 1 -65 17 -11 107 -10 108 2 10 103 -22 147 -93 128z
m62 -93 c0 -16 -7 -20 -30 -20 -18 0 -30 5 -30 13 0 20 10 27 37 27 16 0 23
-6 23 -20z"/>
<path d="M8397 544 c-4 -4 -7 -36 -7 -71 0 -57 2 -63 20 -63 19 0 21 5 18 67
-3 61 -14 84 -31 67z"/>
<path d="M6735 479 c-59 -18 -95 -66 -95 -129 l0 -40 135 0 135 0 0 38 c0 50
-31 97 -79 122 -44 22 -52 23 -96 9z"/>
<path d="M6533 440 c-28 -16 -53 -65 -53 -102 0 -5 27 -8 60 -8 l60 0 0 38 c0
21 7 47 15 58 8 12 11 24 8 28 -13 12 -59 5 -90 -14z"/>
<path d="M6926 452 c-3 -5 1 -26 9 -46 8 -19 15 -45 15 -56 0 -18 6 -20 56
-20 l57 0 -6 37 c-4 20 -17 47 -30 60 -25 25 -90 42 -101 25z"/>
<path d="M5056 402 c-6 -42 15 -66 26 -29 10 37 9 55 -6 60 -9 4 -15 -5 -20
-31z"/>
<path d="M4640 373 c0 -7 9 -13 20 -13 12 0 17 5 14 13 -3 8 -11 14 -19 14 -8
0 -15 -6 -15 -14z"/>
</g>
</svg>




    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
